import { __ } from '@wordpress/i18n';
import React from 'react';
import plIcon from '../../assets/images/pl-icon-sm.svg';
import naviagateIcon from '../../assets/images/navigate-to.svg';
import './Footer.scss';
export default function Footer() {    
 
    return (
        <div className="pl-access-control-footer p-lg">
            <div className="row justify-content-between align-items-center">
                <div className="col-12 d-flex align-items-center gap-3 col-lg-auto text-center text-lg-start">
                    {/* <li>
                        <img src={plIcon} alt="plugin-icon"/>
                        <h6 className='mb-0'>{__("Access Control", 'access-control')}</h6>
                    </li>
                    <li>
                        <span>{__("About", 'access-control')}</span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </li>
                    <li>
                        <span>{__("Privacy", 'access-control')}</span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </li>
                    <li>
                        <span>{__("Terms", 'access-control')}</span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </li>
                    <li>
                        <span>{__("Version 1.0.0", 'access-control')}</span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </li> */}
                     <a href="https://www.programmelab.com/" target="_blank">
                        <img src={plIcon} alt="plugin-icon"/>
                        <h6 className='mb-0'>{__("Access Control", 'access-control')}</h6>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("About", 'access-control')} </span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("Privacy", 'access-control')} </span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("Terms", 'access-control')} </span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </a>
                    <a href="https://www.programmelab.com/" target="_blank">
                        <span>{__("Version "+placAdminData.pluginVersion, 'access-control')} </span>
                        <img src={naviagateIcon} alt="navigate-icon"/>
                    </a>
                </div>
                <div className="coll-12 col-lg-auto text-center text-lg-end">
                    <h6>{__("A ProgrammeLab Product", 'access-control')}</h6>
                </div>
            </div>            
        </div>
    )
}
